import CONSTANTS from '@/constants';

export default {
  getActiveChatMessagesByDates: state => {
    if (!state.activeChatMessages || !state.activeChatMessages.length) return null;

    state.activeChatMessages.forEach(message => {
      message.created_at.slice(0, 10);
    });

    const array = [...state.activeChatMessages];
    const distinctDates = [...new Set(array.map(item => item.created_at.slice(0, 10)))];

    const res = {};

    distinctDates.forEach(date => {
      res[date] = array.filter(msg => msg.created_at.includes(date));
    });

    return res;
  },
  getMessageById: state => id => {
    const message = state.activeChatMessages.find(msg => msg.id === id);

    return message || null;
  },
  getMessagesToRequestParam: state => state.activeChatMessages[0].id,
  getMessagesFromRequestParam: state => state.activeChatMessages[state.activeChatMessages.length - 1].id,
  getContactsFromPrivateChats: state => {
    if (!state.recentChats.length) return [];

    return state.recentChats.filter(chat => chat.type_id === CONSTANTS.chatTypes.private).map(item => item.contact);
  }
};
